module.exports = __webpack_public_path__ + "img/image.7819f78f.png";